(function (ng) {
    

    angular.module('validation', []);
})(window.angular);
